// https://blog.logrocket.com/build-rich-text-editors-react-draft-js-react-draft-wysiwyg/

// -------
import React, { useState } from 'react';
import { EditorState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
// import './App.css';

function TextEditor({ convertedContent, setConvertedContent, setFormData, formData }) {
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
  // const [convertedContent, setConvertedContent] = useState('<h1>ok</h1>');
  const handleEditorChange = (state) => {
    setEditorState(state);
    convertContentToHTML();
  };
  const convertContentToHTML = () => {
    // {draftToHtml(convertToRaw(editorState.getCurrentContent()))}
    let currentContentAsHTML = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    setConvertedContent(currentContentAsHTML);
    if(formData)
    setFormData({...formData, description: currentContentAsHTML});
  };

  return (
    <div style={{ borderRadius: 10, padding: '5px' }}>
      <Editor
        editorState={editorState}
        onEditorStateChange={handleEditorChange}
        wrapperClassName="wrapper-class"
        editorClassName="editor-class"
        toolbarClassName="toolbar-class"
      />
    </div>
  );
}

export default TextEditor;
